import { Link } from "react-router-dom";
import type { Show } from "@/mocks/tv/shows";
import { formatRating } from "@/utils/tv";

interface ShowCardProps {
  show: Show;
}

export default function ShowCard({ show }: ShowCardProps) {
  const typeLabel = show.type === "movie" ? "电影" : "剧集";
  return (
    <Link to={`/detail/${show.id}`} className="group block">
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-background-200">
        <img
          src={show.cover}
          alt={`${show.title}封面`}
          title={`${show.title} - 绍宋影视`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <span className="absolute top-2 left-2 px-2 py-0.5 text-[11px] rounded-full bg-primary-600/85 text-background-50">
          {typeLabel}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 text-[11px] rounded-full bg-black/55 text-accent-300">
          {formatRating(show.rating)}
        </span>
        <div className="absolute bottom-0 left-0 right-0 p-2.5 translate-y-2 opacity-0 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300">
          <span className="inline-flex items-center gap-1 text-[11px] px-2.5 py-1 rounded-full bg-accent-500 text-primary-950 font-medium">
            <i className="ri-play-circle-line text-sm w-4 h-4 flex items-center justify-center" />
            查看详情
          </span>
        </div>
      </div>
      <h3 className="mt-2 text-sm font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
        {show.title}
      </h3>
      <p className="mt-0.5 text-xs text-foreground-500 truncate">
        {show.genres.slice(0, 2).join(" · ")} · {show.year}
      </p>
    </Link>
  );
}